import React from 'react';
import ViewHeader from './view-header';
import ViewContent from './view-content';
import SrMaxicomm from './reportesantonio';
import Otro from './reporte_ventas_clientes';
import Reporte from '../reportes/DistribucionParticipaciones';
import ReporteDestajo from '../reportes/ReporteDestajo';
import Reporteproduccion from '../reportes/reporte_produccion_validar';

import ReporteIndividual from './produccion_individual';


// styling
import './style.css';
import { connect } from 'react-redux';
import * as actions from '../../actions/auth';

class ModalTablas extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
		
        };
	}
	render()
	{
		let user= 0;//parseInt(this.props.user.user,10);
		let departamento=0;

		
        if (typeof(this.props.auth.user) !="undefined")
        {           
            user= parseInt(this.props.auth.user.id);
             departamento= parseInt(this.props.auth.user.departamento);
            // console.log('usuario----->',this.props.auth.user)
       }
		return(

				<div className="view">
					<ViewHeader />
					
					{
						(user==15||user==1||user==9||departamento==4)&&<ReporteDestajo /> 
					}
					{
						(user==15||user==1||user==9||departamento==4)&&<Reporte /> 
					}
					{
						// (user > 0&&user!=15&&user!=1&&user!=9&&departamento!=4)&&<Otro /> 
					}
					{
						(user > 0&&user!=15&&user!=9&&departamento!=4)&&<ReporteIndividual />
					}
					
					
				</div>

			
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth,
    }
};

export default connect(mapStateToProps, actions)(ModalTablas)



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js